// The same reminder-owning reply is returned from source, thread and Library cards.
export const EVENT_ARTIFACT_FIELDS = `
    event { startDate endDate startTime endTime timeZone location rawDate needsReview }
    eventMessage {
        id title body parentMessageId threadRootMessageId eventArtifactId
        event { startDate endDate startTime endTime timeZone location rawDate needsReview }
        dueAt dueTimezone dueKind reminderAt reminderVersion reminderCancelledAt reminderFiredAt
        reminderDeliveryType reminderMessage
        alerts { id offsetMinutes deliveryType firedAt }
    }
`;
